//components
import type { MediaType } from '@/utils/hooks/swr/useLibraryMedia/types/types';

import { DocumentPreview } from '@/components/composite/Scheduler/PostFunnel/MediaPreview/Document/PreviewOfDocument/DocumentPreview';
import MediaDocument from '@/components/composite/Scheduler/PostFunnel/MediaPreview/Document/PreviewOfDocument/MediaDocument';

type PreviewDocumentProps = { document: Extract<MediaType, { type: 'document' }> };

export function PreviewOfDocument({ document }: PreviewDocumentProps) {
    if (document?.pdf) {
        return <MediaDocument pdf={document.pdf} />;
    }

    return <DocumentPreview document={document} />;
}
